import { useSelector } from "react-redux";
import reduxModule from "./redux";

export const useAdvertiser = () => {
  const state = useSelector((state) => state.useAdvertiser);

  return {
    list: (callback = null) => reduxModule.list(callback),
    info: (code, callback = null) => reduxModule.info(code, callback),
    add: (name, code, callback = null) => reduxModule.add(name, code, callback),
    update: (name, code, callback = null) =>
      reduxModule.update(name, code, callback),
    state: state,
    advertiser: state?.advertiser,
  };
};
